export const buildCardImageBaseUrl = (appUrl) => {
  const appUrlWithoutTrailingSlash = appUrl.replace(/[/]+$/, "");
  return `${appUrlWithoutTrailingSlash}/img/`;
};

export const buildCardImageData = (imageUrl, scheme = "card") => {
  const name = scheme.toLowerCase();
  return {
    src: imageUrl + name + ".svg",
    alt: scheme || "payment method",
  };
};
